<template>
  <div class="">
    <!-- <SkeletonTable v-if="loadBar == true"></SkeletonTable> -->
    <v-card class="no-shadow">
      <v-card-title class="ctn_search">
        Estratos
        <v-spacer></v-spacer>
        <v-combobox
          v-if="isMaster"
          class="input_filter"
          ref="company"
          v-model="company"
          :items="itemsDataCompany"
          :search-input.sync="searchCompany"
          item-value="_id"
          item-text="name"
          placeholder="filtrar empresa"
          clearable
        ></v-combobox>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="getHeader"
        :items="itemsData"
        :loading="getLoadTable"
        :footer-props="{
          'items-per-page-options': [10],
        }"
        :items-per-page="10"
        :server-items-length="totalNumberOfItems"
        :options.sync="pagination"
        loading-text="Cargando información …."
        :search="search"
      >
        <template v-slot:[`item.state`]="{ item }">
          <div v-if="item.state == true">
            <v-icon class="i-con on">mdi-checkbox-blank-circle</v-icon>
          </div>
          <div v-else>
            <v-icon class="i-con off">mdi-checkbox-blank-circle</v-icon>
          </div>
        </template>
        <template v-slot:[`item.activate`]="{ item }">
          <div class="lb lb_activo" v-if="item.activate == 1">Activo</div>
          <div class="lb lb_inactivo" v-else>
            <span class="span_inactive">Inactivo</span>
          </div>
        </template>
        <template v-slot:[`item.name`]="{ item }">
          {{ item.name }}
        </template>
        <template v-slot:[`item.company`]="{ item }">
          {{ item.company.name }}
        </template>
        <template v-slot:[`item.description`]="{ item }">
          {{ item.description }}
        </template>
        <template v-slot:[`item.createdAt`]="{ item }">
          {{ item.updateAt | formatDate }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="table_menu"
                color="primary"
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item class="list_action">
                <v-btn plain @click="editItem(item)">
                  <span>Editar</span>
                </v-btn>
              </v-list-item>
              <v-list-item class="list_action">
                <v-btn plain @click="deleteItem(item)">
                  <span>Eliminar</span>
                </v-btn>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>
    <Edit
      :data="itemObjct"
      :visible="EditFlag"
      @close="EditFlag = false"
    ></Edit>
    <Delete
      :data="itemObjct"
      :visible="DeleteFlag"
      @close="DeleteFlag = false"
    ></Delete>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import Edit from "@/components/socialgroup/Edit.vue";
import Delete from "@/components/socialgroup/Delete.vue";
//import SkeletonTable from "@/components/SkeletonTable.vue";
export default {
  name: "SocialTableComp",
  components: {
    Edit,
    Delete,
    //SkeletonTable
  },
  data() {
    return {
      search: "",
      flagTable: true,
      EditFlag: false,
      DeleteFlag: false,
      itemObjct: {},
      itemsData: [],
      totalItems: 0,
      page: 0,
      totalNumberOfItems: 0,
      pagination: {
        page: +this.$route.query.page || 1,
        itemsPerPage: 10,
      },
      searchCompany: "",
      company: null,
      itemsDataCompany: [],
      totalNumberOfItemsComp: 0,
      paginationc: {
        page: +this.$route.query.page || 1,
        itemsPerPage: 10,
      },
      headerMaster: [
        { text: "Activo", value: "activate" },
        {
          text: "Nombre",
          align: "start",
          sortable: false,
          value: "name",
        },
        { text: "Empresa", value: "company" },
        { text: "Descripción", value: "description" },
        { text: "Creado", value: "createdAt" },
        { text: "Acciones", value: "actions", sortable: false },
      ],
      headersClient: [
        { text: "Activo", value: "activate" },
        {
          text: "Nombre",
          align: "start",
          sortable: false,
          value: "name",
        },
        { text: "Empresa", value: "company" },
        { text: "Descripción", value: "description" },
        { text: "Creado", value: "createdAt" },
        { text: "Acciones", value: "actions", sortable: false },
      ],
    };
  },
  async mounted() {
    await this.getJsonData();
    // evento despues de nueva estacion
    this.$root.$on("reload", async () => {
      await this.getJsonData();
    });
  },
  watch: {
    searchCompany: {
      handler() {
        this.getJsonCompany().then((data) => {
          this.itemsDataCompany = data.docs;
        });
        this.getJsonData().then((data) => {
          this.itemsData = data.docs;
        });
      },
      deep: true,
    },
    search: {
      handler() {
        this.getJsonData().then((data) => {
          this.itemsData = data.docs;
        });
      },
      deep: true,
    },
    pagination: {
      handler() {
        this.getJsonData().then((data) => {
          this.itemsData = data.docs;
        });
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(["listSocialGroup", "listCompany"]),
    async getJsonCompany() {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.$store.state.token };
          // console.log('enviando', this.search)

          axios
            .get(
              `company/list?page=${this.paginationc.page}&search=${this.searchCompany}`,
              {
                headers: headerToken,
              }
            )
            .then((res) => {
              //console.log('company', res.data)
              this.itemsDataCompany = res.data.docs;
              this.totalNumberOfItemsComp = res.data.totalDocs;
              resolve(res.data);
            })
            .catch((error) => {
              //console.log(error.response.status)
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async getJsonData() {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.$store.state.token };
          // console.log('enviando', this.search)
          let idCompany = this.company != null ? this.company._id : null;

          axios
            .get(
              `socialgroup/list?page=${this.pagination.page}&search=${this.search}&company=${idCompany}`,
              {
                headers: headerToken,
              }
            )
            .then((res) => {
              //console.log('station', res.data)
              this.itemsData = res.data.docs;
              this.totalNumberOfItems = res.data.totalDocs;
              resolve(res.data);
            })
            .catch((error) => {
              //console.log(error.response.status)
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    editItem(param) {
      this.itemObjct = Object.assign({}, param);
      this.EditFlag = true;
    },
    deleteItem(param) {
      this.itemObjct = Object.assign({}, param);
      this.DeleteFlag = true;
    },
  },
  computed: {
    ...mapGetters(["getListSocialGroup", "isMaster"]),
    getHeader() {
      if (this.isMaster == 1) {
        return this.headerMaster;
      }
      return this.headersClient;
    },
    loadBar() {
      if (this.itemsData.length > 0) {
        return false;
      } else {
        return true;
      }
    },
    getLoadTable() {
      if (this.itemsData.length > 0) {
        return false;
      }
      return true;
    },
  },
  filters: {
    formatDateShort: (value) => {
      if (value) {
        return moment(value).format("LL");
      }
      return "-";
    },
    formatDate: (value) => {
      if (value) {
        return moment(value)
          .locale("es")
          .format("LLL");
      }
      return "-";
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/scss/base.scss";
.table_menu {
  background-color: hsl(120deg 100% 25% / 4%);
}
.input_filter {
  position: relative;
  top: 16px;
  padding: 0 50px;
  width: 80px;
}
.span_inactive {
  color: $alert;
}
.list_action {
  padding: 0 2px;
  &:last-child {
    button:hover,
    a:hover {
      background-color: $alert;
    }
  }
  a,
  button {
    color: $color-text;
    text-decoration: none;
    display: block;
    font-size: 0.9rem;
    padding: 6px 16px;
    border-radius: 2px;
    width: 100%;
    &:hover {
      color: #fff;
      background-color: $color-link;
    }
  }
  span {
    font-size: 0.9rem;
  }
}
i.i-con {
  font-size: 0.8rem !important;
  &.off {
    color: $alert;
  }
  &.on {
    color: $green-btn;
  }
}
</style>
